"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var getStatePovertyLevel_1 = __importDefault(require("./getStatePovertyLevel"));

function isWaivedFee(income, state) {
  var persons = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  // Tabulate Against HHS 150% Poverty Limit
  // http://www.uscourts.gov/sites/default/files/poverty-guidelines.pdf
  return income < (0, getStatePovertyLevel_1.default)(state, Number(persons), 1.5);
}

exports.default = isWaivedFee;